import Services from "api/ProjectApiConsumer";

export function getBankByClient(companyCode) {
  return Services.financialAdminService.getBankByClient(
    undefined,
    undefined,
    companyCode
  );
}

export function getCashFlowAdmin(obj) {
  return Services.financialAdminService.getCashFlowAdmin(obj);
}

export function getIncomeAdmin(obj) {
  return Services.financialAdminService.getIncomeAdmin(obj);
}
